import React from "react";
import { Box, Button, Card, CardContent, Grid, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export interface LogoutWarningTemplateProps {
	readonly onLogoutClicked: () => void;
	readonly onRefreshClicked: () => void;
	readonly isRefreshing: boolean;
	readonly showRefreshError?: boolean;
}

export const LogoutWarningTemplate: React.FC<LogoutWarningTemplateProps> = ({
	onLogoutClicked,
	onRefreshClicked,
	isRefreshing,
	showRefreshError,
}) => {
	return (
		<Box position="absolute" bottom={0} right={0} p={4} sx={{ zIndex: (theme) => theme.zIndex.modal }}>
			<Card elevation={10} variant="elevation">
				<CardContent>
					<Grid container gap={4} alignItems="center" direction="column">
						<Grid container direction="column" alignItems="center">
							<WarningAmberIcon sx={{ color: "warning.main", fontSize: 80 }} />

							<Typography fontWeight="bold">
								<FormattedMessage
									id="logout-warning.header"
									defaultMessage="Your session will expire soon unless you refresh your session"
								/>
							</Typography>

							<Typography variant="caption">
								<FormattedMessage
									id="logout-warning.subheader"
									defaultMessage="If you refresh your session, the page will refresh."
								/>
							</Typography>
						</Grid>

						<Grid container gap={2}>
							<Button
								variant="text"
								type="button"
								onClick={onLogoutClicked}
								data-testid="logout-warning__button__logout"
							>
								<FormattedMessage id="logout-warning.logout" defaultMessage="Log out now" />
							</Button>

							<Button
								variant="contained"
								type="button"
								onClick={onRefreshClicked}
								loading={isRefreshing}
								data-testid="logout-warning__button__refresh"
							>
								<FormattedMessage id="logout-warning.refresh" defaultMessage="Refresh Session" />
							</Button>
						</Grid>

						{showRefreshError === true && (
							<Typography color="error">
								<FormattedMessage
									id="logout-warning-error"
									defaultMessage="We were unable to refresh your token. Please log out and in again"
								/>
							</Typography>
						)}
					</Grid>
				</CardContent>
			</Card>
		</Box>
	);
};
